import { Component, OnInit } from '@angular/core';
import { HomeService } from '../services/home.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-atricles2',
  templateUrl: './atricles2.component.html',
  styleUrls: ['./atricles2.component.css']
})
export class Atricles2Component implements OnInit {
  articles:any=[]
  isLoggedIn:boolean = false
  title:string=''
  yogaArticles:any=[]
  healthArticles:any=[]
  featuredArticles:any=[]
  include:any= ['facebook', 'twitter','whatsapp','pinterest','linkedin']
  blogData:any={title:'',image:'',url:''}
  activeType:any='ALL'
  searchTerm;any=''
  constructor(private homeSvc:HomeService,
    private activatedRoute:ActivatedRoute,
    private auth:AuthService) { }

  ngOnInit() {
    this.isLoggedIn = this.auth.isLoggedin
    this.getAllBlogs()
    this.GetArticles('YOGA')
    this.GetArticles('HEALTH')
   
  }
  searchBlog(){
    if(this.searchTerm!=''){
    this.auth.searchBlog(this.searchTerm,this.activeType).subscribe(res=>{
      if(this.activeType=='ALL'){
        this.articles = res["data"]
      }
      else if(this.activeType=='YOGA'){
        console.log(res["data"])
        this.yogaArticles = res["data"]
        if(localStorage.getItem('token')){
          this.yogaArticlesisLiked()
        }
      }
      else{
        this.healthArticles = res["data"]
      }
    })
  }
  else{
    this.getAllBlogs()
    this.GetArticles('YOGA')
    this.GetArticles('HEALTH')
  }
  }
  GetArticles(type){
    this.homeSvc.getArticles(type).subscribe(res=>{
      console.log(res)
      if(type=='YOGA'){
        this.yogaArticles = res["data"]
        if(localStorage.getItem('token')){
          this.yogaArticlesisLiked()
        }
       
      }
      else{
        this.healthArticles = res["data"]
        if(localStorage.getItem('token')){
          this.healthArticlesisLiked()
        }
      }
     

    },error=>{

    })
  }
  openShare(article){
    this.blogData.image  = article.image
    this.blogData.title = article.title
    this.blogData.url = `https://daktarz.com/blog-detail/${article.uniquekey}`

    document.getElementById('share_trigger').click()
    console.log(article)
  }
  yogaArticlesisLiked(){
    let index 
    this.yogaArticles.map(article=>{
      if(article.reviews){
      index = article.reviews.findIndex(review=>review.userId==JSON.parse(localStorage.getItem('logindata'))['_id'] )      
      if(index>-1){
        article.isLiked = article.reviews[index].isLiked ? article.reviews[index].isLiked: false
      } 
      else{
        article.isLiked = false
      } 
    } 
    else{
      article.isLiked = false
    } 
      })
    
  }
  healthArticlesisLiked(){
    let index 
    this.healthArticles.map(article=>{
      if(article.reviews){
      index = article.reviews.findIndex(review=>review.userId==JSON.parse(localStorage.getItem('logindata'))['_id'] )      
      if(index>-1){
        article.isLiked = article.reviews[index].isLiked ? article.reviews[index].isLiked: false
      } 
      else{
        article.isLiked = false
      } 
    } 
    else{
      article.isLiked = false
    } 
      })
    
  }
  allArticlesisLiked(){
    let index 
    this.articles.map(article=>{
      if(article.reviews){
      index = article.reviews.findIndex(review=>review.userId==JSON.parse(localStorage.getItem('logindata'))['_id'] )      
      if(index>-1){
        article.isLiked = article.reviews[index].isLiked ? article.reviews[index].isLiked: false
      } 
      else{
        article.isLiked = false
      } 
    } 
    else{
      article.isLiked = false
    } 
      })
    
  }
  loginFirst(data){
    if(localStorage.getItem('usertype')=='User' && localStorage.getItem('token')){
      this.like(data)
    }
    else if(!localStorage.getItem('token')){
      document.getElementById('logintoggle_user').click()
    }
    
  }
  like(article){
    let obj={
      isLiked:article.isLiked ? false : true,
      blogId:article._id
    }
    this.auth.addBlogReview(obj).subscribe(res=>{
      this.GetArticles('YOGA')
      this.GetArticles('HEALTH')
      this.getAllBlogs()
    })
  }
  setType(type){
    this.activeType = type
    this.searchTerm = ''
    this.GetArticles('YOGA')
    this.GetArticles('HEALTH')
    this.getAllBlogs()
  }
 
  getAllBlogs(){
    this.homeSvc.getAllBlogs().subscribe(res=>{
      console.log(res)
this.articles = res["data"]
this.featuredArticles = this.articles.filter(article=>{ return article.isFeautered }) 
console.log(this.featuredArticles)
if(localStorage.getItem('token')){
  this.allArticlesisLiked()
}
    },error=>{

    })
  }
  getisFeaturedArticles(){
    
  }
 

}
